import Container from 'components/molecules/Container/Container';
import { ThankYouTemplate } from 'components/organisms/ThankYouTemplate/ThankYouTemplate';
import { ThankYouPageContentType } from 'components/organisms/ThankYouTemplate/ThankYouTemplate.enums';
import { FormType } from 'enums/form';
import { ModalTypes } from 'enums/modalTypes';
import { openModal } from 'graphql/modals';
import { useGetStageCompanyRespondantFormEffect } from 'hooks/useRespondantForm';
import { t } from 'i18next';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader } from '@spotted-zebra-uk/ui-components';

interface IFinishedAssessmentContent {
  companyName: string;
  companyLogoUrl?: string;
  stageCandidateId: number;
  exitUrl: string;
}

const FinishedAssessmentContent: FC<IFinishedAssessmentContent> = ({
  stageCandidateId,
  companyName,
  companyLogoUrl,
  exitUrl,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(exitUrl);
  };

  const [
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    _getStageCompanyRespondantFormResult,
    isLoading,
  ] = useGetStageCompanyRespondantFormEffect(
    stageCandidateId,
    FormType.CD_FORM,
    getRespondantFormResult => {
      if (
        getRespondantFormResult?.data?.respondantForm &&
        getRespondantFormResult.data.respondantForm.respondantFieldWithAnswers
          .length &&
        !getRespondantFormResult.data.respondantForm.isComplete
      ) {
        openModal({
          modalType: ModalTypes.EQUALITY_AND_DIVERSITY_MODAL,
          modalProps: {
            stageCandidateId,
            companyLogoUrl,
          },
        });
      }
    }
  );

  const mainText = t('assessment.congratulations');

  if (isLoading) {
    return (
      <Container className="page-loader-wrapper">
        <Loader variant="bubbles" />
      </Container>
    );
  }

  return (
    <ThankYouTemplate
      mainText={mainText}
      onClick={handleClick}
      contentType={ThankYouPageContentType.FINISHED_STAGE_WITHOUT_REPORT}
      companyLogoUrl={companyLogoUrl}
      companyName={companyName}
    />
  );
};

export default FinishedAssessmentContent;
